export default __webpack_public_path__ + "b0b9979.png";